module.exports = __webpack_public_path__ + "static/DEAL MAP-LOGO-d4a5412298b0267eda0c882f3e4e521c.png";